import {Component, OnInit} from '@angular/core';
import {I18NService} from '../../i18n/i18n.service';
import {MsgBoxService} from '../../shared/msg-box.service';
import {ActivatedRoute} from '@angular/router';
import {ECMemberAccessType, ECMemberParticipationType} from "smag-commons/cfg/hierarchy";

@Component({
    selector: 'app-onboarding-completed',
    templateUrl: './onboarding-completed.component.html',
    styleUrls: ['./onboarding-completed.component.scss']
})
export class OnboardingCompletedComponent implements OnInit {

    communityName: string;
    webAppUrl: string;
    androidAppUrl: string;
    iosAppUrl: string;
    ctrlUrl: string;
    accessType: string;
    participationType: string;

    // Exported in HTML
    MOBILE = ECMemberAccessType.MOBILE;
    ADVANCED = ECMemberAccessType.ADVANCED;
    NONE = ECMemberAccessType.NONE;
    MEMBER = ECMemberParticipationType.MEMBER;
    THIRD_PARTY_PRODUCER = ECMemberParticipationType.THIRD_PARTY_PRODUCER;

    constructor(private readonly i18n: I18NService,
                private readonly msgBoxService: MsgBoxService,
                private readonly route: ActivatedRoute) {
    }

    ngOnInit() {
        this.communityName = this.route.snapshot.queryParamMap.get('communityName');
        this.webAppUrl = this.route.snapshot.queryParamMap.get('webAppUrl');
        this.androidAppUrl = this.route.snapshot.queryParamMap.get('androidAppUrl');
        this.iosAppUrl = this.route.snapshot.queryParamMap.get('iosAppUrl');
        this.ctrlUrl = this.route.snapshot.queryParamMap.get('ctrlUrl');
        this.accessType = this.route.snapshot.queryParamMap.get('accessType');
        this.participationType = this.route.snapshot.queryParamMap.get('participationType');
    }

    get language(): string {
        return this.i18n.language;
    }
}
